module.exports = __webpack_public_path__ + "static/media/30-1.eee4c079.mp3";